export const legacyRoutes = {
  list: '/admin/legacy-distributor',
  add: '/admin/legacy-distributor/add',
  edit: '/admin/legacy-distributor/:itemId',
  getEditLink: (itemId: string) => `/admin/legacy-distributor/${itemId}`,
};
